<template>
  <div class="loader-btn" />
</template>

<style lang="scss" scoped>
@use "@/assets/style/_color.scss" as *;

.loader-btn {
  position: relative;
  left: 0%;
  border: 3px solid $neutral-0;
  border-radius: 50%;
  border-top: 3px solid $dark-blue-4;
  width: 15px;
  height: 15px;
  -webkit-animation: spin 1.5s linear infinite;
  /* Safari */
  animation: spin 1.5s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
